import React, { Component } from 'react';
import { Button, Table } from 'reactstrap';
import Steps, { Step } from 'rc-steps';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import axios from 'axios';
import swal from 'sweetalert';
import { checkEmailFormat } from 'helperfunctions';

const INITIAL_TYPES = [
	{ id: 2, name: 'Ampel' },
	{ id: 3, name: 'Beleuchtung' },
	{ id: 4, name: 'Schild' },
	{ id: 17, name: 'Verkehr' },
	{ id: 19, name: 'Ruhender Verkehr' },
	{ id: 20, name: 'Fließender Verkehr' },
	{ id: 65, name: 'Verkehrsthemen' },
	{ id: 37, name: 'Parkscheinautom.' },

	{ id: 9, name: 'Straße' },
	{ id: 41, name: 'Straßen und Wege' },
	{ id: 57, name: 'Gehweg/Radweg' },
	{ id: 46, name: 'Waldwege' },

	{ id: 10, name: 'Vandalismus' },
	{ id: 11, name: 'Verschmutzung' },
	{ id: 12, name: 'Müll' },
	{ id: 45, name: 'Voller Mülleimer' },
	{ id: 62, name: 'Abfalleimer' },
	{ id: 27, name: 'Straßenreinigung' },

	{ id: 1, name: 'Sturmschaden' },
	{ id: 47, name: 'Bäume' },
	{ id: 30, name: 'Bäume/Hecken' },
	{ id: 48, name: 'Parkanlagen' },
	{ id: 13, name: 'Wildwuchs' },

	{ id: 5, name: 'Gebäude' },
	{ id: 59, name: 'Städt. Gebäude' },
	{ id: 14, name: 'Friedhof' },
	{ id: 6, name: 'Kanaldeckel' },
	{ id: 25, name: 'Sportstätten' },
	{ id: 8, name: 'Spielplatz' },

	{ id: 23, name: 'EPS (Eichenprozessionsspinner)' },
	{ id: 26, name: 'Schädlinge' },
	{ id: 60, name: 'Wild/Tiere' },
	{ id: 7, name: 'Hundehaufen' },

	{ id: 18, name: 'Gewässer' },
	{ id: 33, name: 'Ab/Wasser' },
	{ id: 36, name: 'Kanal' },
	{ id: 61, name: 'See/Gewässer' },

	{ id: 16, name: 'Sonstiges' },
	{ id: 40, name: 'Lob und Kritik' },
	{ id: 39, name: 'Lärm' }
];

class SetUpForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			step: 0,
			users: [
				{
					id: 0,
					firstName: '',
					lastName: '',
					email: '',
					role: '',
					formOfAddress: 0,
					invalid: {
						firstName: false,
						lastName: false,
						email: false,
						role: false,
						formOfAddress: false
					}
				}
			],
			groups: [{ name: '', user: [], groupAdmins: [], invalid: { name: false } }],
			types: INITIAL_TYPES,
			customTypeValue: '',
			organisation: '',
			contactEmail: '',
			sendLoading: false,
			webType: 'disabled',
			reportCollection: true,
			reportSearch: true,
			reportDetails: true,
			newReport: true
		};
	}

	setUserParam = (param, value, index) => {
		this.setState({
			users: this.state.users.map((user, stateIndex) =>
				stateIndex === index ? { ...user, [param]: value, invalid: { ...user.invalid, [param]: false } } : user
			)
		});
	};

	setGroupParam = (param, value, index) => {
		this.setState({
			groups: this.state.groups.map((group, stateIndex) =>
				stateIndex === index ? { ...group, [param]: value, invalid: { ...group.invalid, [param]: false } } : group
			)
		});
	};

	addUser = () => {
		this.setState({
			users: [
				...this.state.users,
				{
					id: this.state.users.length,
					firstName: '',
					lastName: '',
					email: '',
					role: '',
					formOfAddress: 0,
					invalid: {
						firstName: false,
						lastName: false,
						email: false,
						role: false,
						formOfAddress: false
					}
				}
			]
		});
	};

	addGroup = () => {
		this.setState({
			groups: [...this.state.groups, { name: '', user: [], groupAdmins: [], invalid: { name: false } }]
		});
	};

	getResponsible = value => {
		const type = value.split('_');
		if (type[0] === 'User') {
			const user = this.state.users[parseInt(type[1])];
			return { type: 'Benutzer', index: type[1], name: `${user.firstName} ${user.lastName}` };
		}
		if (type[0] === 'Group') {
			const group = this.state.groups[parseInt(type[1])];
			return { type: 'Gruppe', index: type[1], name: group.name, isGroup: true, userCount: group.user.length };
		}
		return value;
	};

	typeNextDisabled = () => {
		return false;
	};

	submitData = async () => {
		try {
			const { users, groups, types, webType, reportCollection, reportSearch, reportDetails, newReport } = this.state;
			this.setState({ sendLoading: true });
			const response = await axios.post(
				// 'http://0.0.0.0:3010/v2/organisation/setup',
				'https://www.meldooplus.de/api/v2/organisation/setup',
				{
					organisation: this.state.organisation,
					contactEmail: this.state.contactEmail,
					users,
					groups,
					types: types.filter(t => t.selected),
					web: { webType, reportCollection, reportSearch, reportDetails, newReport }
				}
			);
			this.setState({
				step: 0,
				users: [
					{
						id: 0,
						firstName: '',
						lastName: '',
						email: '',
						role: '',
						formOfAddress: 0,
						invalid: {
							firstName: false,
							lastName: false,
							email: false,
							role: false,
							formOfAddress: false
						}
					}
				],
				groups: [{ name: '', user: [], groupAdmins: [], invalid: { name: false } }],
				types: INITIAL_TYPES,
				organisation: '',
				contactEmail: '',
				sendLoading: false,
				webType: 'disabled',
				reportCollection: true,
				reportSearch: true,
				reportDetails: true,
				newReport: true
			});
			swal(
				'Konfiguration abgeschlossen',
				'Wir informieren Sie sobald die Einrichtung der Benutzer, Gruppen und deren Zuständigkeiten abgeschlossen ist.',
				'success'
			);
		} catch (error) {
			swal('Konfiguration fehlgeschlagen', 'Bitte versuchen Sie es später erneut oder kontaktieren Sie uns unter info@leanact.de', 'error');
		}
	};

	checkUserData = () => {
		let dataCheck = true;
		this.state.users.map((u, i) => {
			const { firstName, lastName, email, role, formOfAddress } = u;
			if (firstName && lastName && email && checkEmailFormat(email) && role && formOfAddress) return;
			dataCheck = false;
			this.setState({
				users: this.state.users.map((user, index) =>
					index === i
						? {
								...user,
								invalid: {
									firstName: firstName ? false : true,
									lastName: lastName ? false : true,
									email: email && checkEmailFormat(email) ? false : true,
									role: role ? false : true,
									formOfAddress: formOfAddress ? false : true
								}
						  }
						: user
				)
			});
		});
		if (dataCheck) this.setState({ step: 1 });
	};

	checkGroupData = () => {
		let dataCheck = true;
		this.state.groups.map((g, i) => {
			const { name, user } = g;
			if (user.length === 0 || name.trim() !== '') return;
			dataCheck = false;
			this.setState({
				groups: this.state.groups.map((group, index) =>
					index === i
						? {
								...group,
								invalid: {
									name: true
								}
						  }
						: group
				)
			});
		});
		if (dataCheck) this.setState({ step: 2 });
	};

	renderContent() {
		switch (this.state.step) {
			case 0:
				return (
					<div>
						<h3>Benutzer anlegen</h3>
						<p>
							Geben Sie hier die Daten der Mitarbeiter an, die einen Zugang zum System MeldooPLUS erhalten sollen. Geben Sie dazu
							zunächst die geforderten persönlichen Daten an. Wählen Sie abschließend die Berechtigungen über die Mitarbeiter verfügen
							können sollen aus.
						</p>
						<p> Für die Rechtevergabe gilt:</p>
						<p>
							<b>Normale Benutzer</b> haben die die Rechte Meldungen die Ihnen zugewiesen wurden zu bearbeiten und mit dem Melder zu
							interagieren.
						</p>
						<p>
							<b>Abteilungsadministratoren</b> haben zusätzlich zu den Rechten des Benutzers auch die Möglichkeit Benutzer anzulegen und
							die allgemeinen Einstellung des Systems vorzunehmen. Zusätzlich können Abteilungsadministratoren in Gruppen als
							"Gruppenadministrator" festgelegt werden. Dadurch erhält der Abteilungsadministrator Zugriff auf alle Meldungen die
							Mitgliedern der jeweiligen Gruppe zugewiesen sind.
						</p>
						<p>
							<b>Verwaltungsadministratoren</b> haben zusätzlich zu den Rechten des Abteilungsadministrators Zugriff auf alle Meldungen
							der gesamten Verwaltung.
						</p>
						{this.state.users.map((user, index) => (
							<div className="row border-top pt-3" key={index} style={{ position: 'relative' }}>
								<div
									style={{ position: 'absolute', right: -13, top: 'calc(50% - 13px)' }}
									className="pointer p-1"
									onClick={() => this.setState({ users: this.state.users.filter((u, i) => i !== index) })}
								>
									<i className="zmdi zmdi-close zmdi-hc-fw" />
								</div>
								<div className="col-md-3 col-12">
									<div className="form-group">
										<select
											className={`custom-select ${user.invalid.formOfAddress ? 'is-invalid' : ''}`}
											id="formOfAddress"
											onChange={m => this.setUserParam('formOfAddress', m.target.value, index)}
											value={user.formOfAddress || 0}
											style={{ height: 33 }}
										>
											<option value={0}>Anrede</option>
											<option value={1}>Herr</option>
											<option value={2}>Frau</option>
										</select>
										<div className="invalid-feedback">Sie müssen eine Anrede auswählen</div>
									</div>
								</div>
								<div className="col-md-4 col-12">
									<div className="form-group">
										<input
											className={`form-control ${user.invalid.firstName ? 'is-invalid' : ''}`}
											value={user.firstName}
											onChange={m => this.setUserParam('firstName', m.target.value, index)}
											type="text"
											placeholder="Vorname"
											maxLength={100}
										/>
										<div className="invalid-feedback">Sie müssen einen Vornamen angeben</div>
									</div>
								</div>
								<div className="col-md-5 col-12">
									<div className="form-group">
										<input
											className={`form-control ${user.invalid.lastName ? 'is-invalid' : ''}`}
											value={user.lastName}
											onChange={m => this.setUserParam('lastName', m.target.value, index)}
											type="text"
											placeholder="Nachname"
											maxLength={100}
										/>
										<div className="invalid-feedback">Sie müssen einen Nachnamen angeben</div>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="form-group">
										<input
											className={`form-control ${user.invalid.email ? 'is-invalid' : ''}`}
											value={user.email}
											onChange={m => this.setUserParam('email', m.target.value, index)}
											type="text"
											placeholder="Email-Adresse"
											maxLength={100}
										/>
										<div className="invalid-feedback">Sie müssen eine gültige Email-Adresse angeben</div>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="form-group">
										<select
											className={`custom-select ${user.invalid.role ? 'is-invalid' : ''}`}
											onChange={m => this.setUserParam('role', m.target.value, index)}
											value={user.role}
											style={{ height: 33 }}
										>
											<option value="">Systemrolle wählen...</option>
											<option value="Verwaltungsadminstrator">Verwaltungsadminstrator</option>
											<option value="Abteilungsadministrator">Abteilungsadministrator</option>
											<option value="Normaler Benutzer">Normaler Benutzer</option>
										</select>
										<div className="invalid-feedback">Sie müssen eine Systemrolle auswählen</div>
									</div>
								</div>
							</div>
						))}
						<div className="row">
							<div className="col-12">
								<div className="d-flex mb-0">
									<Button color="default" className="jr-btn btn-grey btn jr-btn-sm right ml-auto" onClick={this.addUser}>
										Weiteren Nutzer hinzufügen
									</Button>
									<Button color="default" className="jr-btn btn-blue btn jr-btn-sm right" onClick={this.checkUserData}>
										Nächster Schritt
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			case 1:
				return (
					<div>
						<h3>Gruppen anlegen</h3>
						<p>
							Falls mehrere Benutzer für eine Meldungskategorie zuständig sein sollten, können diese in einer Gruppe zusammengefasst
							werden. Dies könnten beispielsweise Ämter oder Fachgruppen sein.
						</p>

						{this.state.groups.map((group, index) => (
							<div className="row border-top pt-3" style={{ position: 'relative' }} key={index}>
								<div
									style={{ position: 'absolute', right: -13, top: 'calc(50% - 13px)' }}
									className="pointer p-1"
									onClick={() => this.setState({ groups: this.state.groups.filter((g, i) => i !== index) })}
								>
									<i className="zmdi zmdi-close zmdi-hc-fw" />
								</div>
								<div className="col-12">
									<div className="form-group">
										<input
											className={`form-control ${group.invalid.name ? 'is-invalid' : ''}`}
											value={group.name}
											onChange={m => this.setGroupParam('name', m.target.value, index)}
											type="text"
											placeholder="Name"
											maxLength={100}
										/>
									</div>
								</div>
								<div className="col-12 pb-3">
									<Typeahead
										id="userFilter"
										onChange={user => {
											this.setGroupParam('user', user, index);
										}}
										options={this.state.users
											.filter(user => !group.user.find(groupUser => user.id === groupUser.id))
											.map(user => {
												return {
													...user,
													label: `${user.firstName} ${user.lastName}`
												};
											})}
										selected={group.user.map(user => {
											return {
												...user,
												label: `${user.firstName} ${user.lastName}`
											};
										})}
										clearButton
										multiple
										placeholder="Mitglieder auswählen..."
										emptyLabel="Keine Benutzer zur Auswahl"
									/>
								</div>

								<div className="col-12 pb-3">
									<p className="small">
										Nur Benutzer mit der Systemrolle "Abteilungsadministrator" können als Gruppenadministrator festgelegt werden.
										Gruppenadministratoren müssen zuvor als Mitglied zu Gruppe hinzugefügt werden.
									</p>
									<Typeahead
										id="groupAdmminFilter"
										onChange={user => {
											this.setGroupParam('groupAdmins', user, index);
										}}
										options={group.user
											.filter(
												user =>
													user.role === 'Abteilungsadministrator' &&
													!group.groupAdmins.find(groupUser => user.id === groupUser.id)
											)
											.map(user => {
												return {
													...user,
													label: `${user.firstName} ${user.lastName}`
												};
											})}
										selected={group.groupAdmins.map(user => {
											return {
												...user,
												label: `${user.firstName} ${user.lastName}`
											};
										})}
										clearButton
										multiple
										placeholder="Gruppenadministratoren auswählen..."
										emptyLabel="Keine Benutzer zur Auswahl"
									/>
								</div>
							</div>
						))}
						<div className="row">
							<div className="col-12">
								<div className="d-flex mb-0">
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm left mr-auto"
										onClick={() => this.setState({ step: 0 })}
									>
										Zurück
									</Button>
									<Button color="default" className="jr-btn btn-grey btn jr-btn-sm right ml-auto" onClick={this.addGroup}>
										Weitere Gruppe hinzufügen
									</Button>
									<Button color="default" className="jr-btn btn-blue btn jr-btn-sm right" onClick={this.checkGroupData}>
										Nächster Schritt
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			case 2:
				return (
					<div>
						<h3>Zuständigkeiten</h3>
						<p>
							Wählen Sie die Kategorien aus denen Meldungen in Ihrem Verwaltungsgebiet zugeordnet werden sollen. Wählen Sie dazu
							zunächst aus der Liste der bestehenden Kategorien. Falls Sie zusätzliche individuelle Kategorien benötigen, können Sie
							diese im Bereich "Individuelle Kategorie hinzufügen" zur Auswahl hinzufügen.
						</p>
						<p>
							<strong>
								Wir empfehlen die Auswahl von Kategorien auf eine Anzahl von 12 bis 15 einzugrenzen. Dadurch können wir eine
								Nutzerfreundliche Darstellung innerhalb der Meldoo App sicherstellen.
							</strong>
						</p>
						<div className="mb-3">
							<Typeahead
								id="typeFilter"
								onChange={types =>
									this.setState({
										types: this.state.types.map(t =>
											types.find(type => type.id === t.id) ? { ...t, selected: true } : { ...t, selected: false }
										)
									})
								}
								options={this.state.types.filter(type => !type.selected)}
								selected={this.state.types.filter(type => type.selected)}
								clearButton
								multiple
								placeholder="Kategorien auswählen..."
								emptyLabel="Keine Kategorien zur Auswahl"
								labelKey="name"
							/>
						</div>

						<p>Individuelle Kategorie hinzufügen:</p>
						<div className="d-flex">
							<div className="form-group w-100">
								<input
									className="form-control"
									value={this.state.customTypeValue}
									onChange={m => this.setState({ customTypeValue: m.target.value })}
									type="text"
									placeholder="Bezeichnung der Kategorie (max. 16 Zeichen)"
									maxLength={16}
								/>
							</div>
							<Button
								color="default"
								className="jr-btn btn-grey btn jr-btn-sm ml-3"
								style={{ height: 33 }}
								onClick={() =>
									this.setState({
										types: [
											...this.state.types,
											{ id: new Date().getTime(), name: this.state.customTypeValue, selected: true, custom: true }
										],
										customTypeValue: ''
									})
								}
							>
								Hinzufügen
							</Button>
						</div>

						<div className="table-responsive-material">
							<Table className="table-middle fst-td-br-tp-0 mb-0">
								<tbody>
									{this.state.types
										.filter(type => type.selected)
										.map((t, i) => (
											<tr key={`Type_${i}`}>
												<td>{t.name}</td>
												<td>
													<select
														className="custom-select"
														onChange={m =>
															this.setState({
																types: this.state.types.map(type =>
																	type.id === t.id ? { ...type, responsible: m.target.value } : type
																)
															})
														}
														value={t.responsible}
													>
														<option>Zuständigkeit wählen...</option>
														{this.state.groups
															.filter(group => group.name)
															.map((group, index) => (
																<option key={`Group_${index}`} value={`Group_${index} - ${group.name}`}>
																	{`${group.name}${
																		group.user.length === 0 ? ' (Achtung! Gruppe hat keine Benutzer)' : ''
																	}`}
																</option>
															))}
														{this.state.users.map((user, index) => (
															<option
																key={`User_${index}`}
																value={`User_${index} - ${user.firstName} ${user.lastName}`}
															>
																{`${user.firstName} ${user.lastName}`}
															</option>
														))}
													</select>
												</td>
											</tr>
										))}
								</tbody>
							</Table>
						</div>
						<div className="row">
							<div className="col-12">
								<div className="d-flex mb-0">
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm left mr-auto"
										onClick={() => this.setState({ step: 1 })}
									>
										Zurück
									</Button>
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm right"
										onClick={() => this.setState({ step: 3 })}
										disabled={this.typeNextDisabled()}
									>
										Nächster Schritt
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			case 3:
				return (
					<div>
						<h3>MeldooWeb für Ihre Webseite</h3>
						<p>
							Mit MeldooWeb bieten wir Ihnen die Möglichkeit Meldoo als Webformular direkt in Ihre Webseite zu integrieren. Dabei haben
							Sie die Wahl zwischen einer Version, welche direkt als iFrame in die Struktur Ihrer Webseite eingebettet wird und einer
							sogenannten Stand-alone-Lösung, welche über einen Link auf Ihrer Webseite aufgerufen werden kann und unabhängig von Ihrer
							Webseite ist.
						</p>
						<p className="mt-4">Möchten Sie MeldooWeb für Ihre Webseite einrichten? Wenn ja, in welcher Form?</p>

						<div className="row">
							<div className="col-12">
								<div className="d-flex row mx-0 mb-3">
									<div className="custom-control custom-radio mr-4">
										<input
											type="radio"
											name="webType"
											id="webTypeDisabled"
											className="custom-control-input"
											value="disabled"
											onChange={m =>
												this.setState({
													webType: m.target.value
												})
											}
											checked={this.state.webType === 'disabled'}
										/>
										<label className="custom-control-label mt-1" htmlFor="webTypeDisabled">
											Kein MeldooWeb
										</label>
									</div>
									<div className="custom-control custom-radio mr-4">
										<input
											type="radio"
											name="webType"
											id="webTypeIFrame"
											className="custom-control-input"
											value="iFrame"
											onChange={m =>
												this.setState({
													webType: m.target.value
												})
											}
											checked={this.state.webType === 'iFrame'}
										/>
										<label className="custom-control-label mt-1" htmlFor="webTypeIFrame">
											iFrame
										</label>
									</div>
									<div className="custom-control custom-radio mr-4">
										<input
											type="radio"
											name="webType"
											id="webTypeStandAlone"
											className="custom-control-input"
											value="standAlone"
											onChange={m =>
												this.setState({
													webType: m.target.value
												})
											}
											checked={this.state.webType === 'standAlone'}
										/>
										<label className="custom-control-label mt-1" htmlFor="webTypeStandAlone">
											Stand-alone-Lösung
										</label>
									</div>
								</div>
							</div>
						</div>
						{(this.state.webType === 'iFrame' || this.state.webType === 'standAlone') && (
							<div className="row mb-3">
								<div className="col-12">
									<p className="mb-0">Welche Module des Webformulars möchten Sie aktivieren?</p>
								</div>
								<div className="col-12">
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="modulesReportCollection"
											checked={this.state.reportCollection}
											onChange={() =>
												this.setState({
													reportCollection: !this.state.reportCollection
												})
											}
										/>
										<label className="custom-control-label mt-1" htmlFor="modulesReportCollection">
											Meldungsübersicht{' - '}
											<a href="https://www.meldooplus.de/v2/#/meldoo-web/leanact" target="_blank">
												Beispiel ansehen
											</a>
										</label>
									</div>
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="modulesReportSearch"
											checked={this.state.reportSearch}
											onChange={() =>
												this.setState({
													reportSearch: !this.state.reportSearch
												})
											}
										/>
										<label className="custom-control-label mt-1" htmlFor="modulesReportSearch">
											Meldungssuche{' - '}
											<a href="https://www.meldooplus.de/v2/#/meldoo-web/leanact/search" target="_blank">
												Beispiel ansehen
											</a>
										</label>
									</div>
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="modulesReportDetails"
											checked={this.state.reportDetails}
											onChange={() =>
												this.setState({
													reportDetails: !this.state.reportDetails
												})
											}
										/>
										<label className="custom-control-label mt-1" htmlFor="modulesReportDetails">
											Meldungsdetails{' - '}
											<a href="https://www.meldooplus.de/v2/#/meldoo-web/leanact/details/10473" target="_blank">
												Beispiel ansehen
											</a>
										</label>
									</div>
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="modulesNewReport"
											checked={this.state.newReport}
											onChange={() =>
												this.setState({
													newReport: !this.state.newReport
												})
											}
										/>
										<label className="custom-control-label mt-1" htmlFor="modulesNewReport">
											Meldungsformular{' - '}
											<a href="https://www.meldooplus.de/v2/#/meldoo-web/leanact/new" target="_blank">
												Beispiel ansehen
											</a>
										</label>
									</div>
								</div>
							</div>
						)}
						<div className="row">
							<div className="col-12">
								<div className="d-flex mb-0">
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm left mr-auto"
										onClick={() => this.setState({ step: 2 })}
									>
										Zurück
									</Button>
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm right"
										onClick={() => this.setState({ step: 4 })}
									>
										Nächster Schritt
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			case 4:
				return (
					<div>
						<h3>Daten bestätigen und absenden</h3>
						<p>
							Sobald Sie die Daten bestätigen, werden wir die Einrichtung des Systems vornehmen. Ist Diese abgeschlossen erhalten die
							jeweiligen Nutzer ihre individuellen Zugangsdaten per E-Mail.
						</p>
						<p className="mt-4">
							Für welche Organisation sollen wir die Einrichtung von Meldoo vornehmen und wie können wir Sie erreichen? Bitte geben Sie
							den Namen Ihrer Organisation und Ihre Email-Adresse an.
						</p>
						<div className="row">
							<div className="col-12">
								<div className="form-group">
									<input
										className="form-control"
										value={this.state.organisation}
										onChange={m => this.setState({ organisation: m.target.value })}
										type="text"
										placeholder="Geben Sie den Namen Ihrer Organisation an"
										maxLength={100}
									/>
								</div>
							</div>
							<div className="col-12">
								<div className="form-group">
									<input
										className="form-control"
										value={this.state.contactEmail}
										onChange={m => this.setState({ contactEmail: m.target.value })}
										type="text"
										placeholder="Geben Sie Ihre Email-Adresse an"
										maxLength={100}
									/>
								</div>
							</div>
							<div className="col-12">
								<div className="d-flex mb-0">
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm left mr-auto"
										onClick={() => this.setState({ step: 3 })}
									>
										Zurück
									</Button>
									<Button
										color="default"
										className="jr-btn btn-blue btn jr-btn-sm right"
										onClick={this.submitData}
										disabled={!this.state.organisation || !this.state.contactEmail}
									>
										Absenden
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			default:
				return null;
		}
	}

	render() {
		return (
			<main className="app-main-content-wrapper">
				<div className="app-main-content">
					<div className="app-login-container d-flex flex-column justify-content-center align-items-center">
						<img className="mini-logo-img-hover mt-4" alt="..." src="assets/images/logo-meldoo.svg" width="230" />
						<div className="jr-card mt-4">
							<div className="row">
								<div className="col-12">
									<h1>Meldoo einrichten</h1>
								</div>
								<div className="col-12">
									<div className="w-100" style={{ paddingRight: 36 }}>
										<Steps current={this.state.step} direction="horizontal" labelPlacement="vertical">
											<Step icon={<i className="zmdi zmdi-account zmdi-hc-lg" />} />
											<Step icon={<i className="zmdi zmdi-accounts zmdi-hc-lg" />} />
											<Step icon={<i className="zmdi zmdi-alert-triangle zmdi-hc-lg" />} />
											<Step icon={<i className="zmdi zmdi-laptop zmdi-hc-lg" />} />
											<Step icon={<i className="zmdi zmdi-check zmdi-hc-lg" />} />
										</Steps>
									</div>
								</div>
								<div className="col-12 mt-3">{this.renderContent()}</div>
							</div>
						</div>
					</div>
				</div>
			</main>
		);
	}
}

export default SetUpForm;



// WEBPACK FOOTER //
// ./containers/SetUpForm/index.js